module.exports = __webpack_public_path__ + "static/img/bg-4.ec4c09e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-4.png
// module id = Co0g
// module chunks = 0